module.exports = __webpack_public_path__ + "img/ico-marker-selected.63a13fe6.svg";